export default __webpack_public_path__ + "static/media/distribuidora.11c68d58.png";